import {
  Edit,
  SimpleForm,
  NumberInput,
  TextInput,
  DateInput,
  SelectInput,
  required,
  minValue,
} from "react-admin";
import type { EditProps } from "react-admin";

const STATUS = [
  { id: "ACTIVE", name: "Active" },
  { id: "CLOSED", name: "Closed" },
];

export const ProjectKarzanEdit = (props: EditProps) => (
  <Edit
    {...props}
    transform={(data: Record<string, unknown>) => ({
      lenderName:
        typeof data.lenderName === "string" ? data.lenderName.trim() || undefined : data.lenderName,
      lenderReference:
        typeof data.lenderReference === "string"
          ? data.lenderReference.trim() || undefined
          : data.lenderReference,
      principalAmount: Number(data.principalAmount),
      disbursementDate: data.disbursementDate || undefined,
      status: data.status,
      remarks: typeof data.remarks === "string" ? data.remarks.trim() || undefined : data.remarks,
    })}
  >
    <SimpleForm>
      <TextInput source="lenderName" fullWidth />
      <TextInput source="lenderReference" fullWidth />
      <NumberInput source="principalAmount" validate={[required(), minValue(1)]} />
      <DateInput source="disbursementDate" />
      <SelectInput source="status" choices={STATUS} />
      <TextInput source="remarks" multiline fullWidth />
    </SimpleForm>
  </Edit>
);
